import {
  CardContent,
  Grid,
  Typography,
  TableHead,
  Tooltip,
  Chip,
  // Button,
  // Checkbox,
  // IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  AdminTitleHolder,
  CustomDocumentLink,
} from "../../../common/sharedComponents/styles/card.style";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
import { styled as materialStyles } from "@mui/material/styles";
import Card from "@mui/material/Card";
import styled from "styled-components";
import {
  // approveItem,
  approvePr,
  getAdminPrDetails,
} from "../redux/adminPrsSlice";
import InfoIcon from "@mui/icons-material/Info";
import {
  CustomTableContainer,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment";
import LocalStorage from "../../../utilities/localStorage";
import { history } from "../../../app/history";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import {
  ApproveButton,
  RejectButton,
} from "../../vendorRegistration/components/ViewvendorDetails";
import { Editor } from "react-draft-wysiwyg";
import { capitalizeString } from "../../../utilities/helper";

function AdminPrsViewContent() {
  const clientId = LocalStorage.getItem("client").id;
  const { adminPrDetails, approve_reject_loading, loading } = useSelector(
    (state) => state.adminPrs
  );

  const [open, setOpen] = React.useState(false);
  const [openRej, setOpenRej] = React.useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const itemList = adminPrDetails?.item_list || [];

  const dispatch = useDispatch();

  const params = useParams();
  const pr_id = params.prid;

  const viewPrDetails = (pr_id) => {
    dispatch(getAdminPrDetails(pr_id));
  };
  const handleAcceptRejectFc = (type) => {
    const payload = {
      pr_id: pr_id,
      is_approved: type === "approve" ? true : false,
      is_rejected: type === "reject" ? true : false,
    };

    if (editorState.getCurrentContent().hasText()) {
      payload["reason"] = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
    } else {
      payload["reason"] = "";
    }
    dispatch(approvePr(payload)).then((response) => {
      if (type === "approve") {
        setOpen(false);
        setEditorState(EditorState.createEmpty());
      } else {
        setOpenRej(false);
        setEditorState(EditorState.createEmpty());
      }
      if (response.payload.success === true) {
        history.push(`/app/prs-list/assigned`);
        viewPrDetails(pr_id);
      }
    });
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditorState(EditorState.createEmpty());
  };

  const handleCloseRej = () => {
    setOpenRej(false);
    setEditorState(EditorState.createEmpty());
  };

  const handleClickOpenReject = () => {
    setOpenRej(true);
  };

  useEffect(() => {
    viewPrDetails(pr_id);
    // eslint-disable-next-line
  }, []);

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
    </Box>
  ) : (
    <>
      <AdminTitleHolder>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            PR#
            {adminPrDetails?.pr_number
              ? adminPrDetails.pr_number
              : "Not Applicable"}
          </Grid>
          {adminPrDetails?.showButton === true ? (
            <Grid item xs={6}>
              {" "}
              <ApproveButton
                onClick={handleClickOpen}
                variant="outlined"
                color="success"
                style={{
                  height: "40px",
                  width: "150px",
                  float: "right",
                }}
              >
                Approve
              </ApproveButton>
              <RejectButton
                onClick={handleClickOpenReject}
                variant="outlined"
                color="error"
                style={{
                  height: "40px",
                  width: "150px",
                  float: "right",
                  marginInline: "1rem",
                }}
              >
                Reject
              </RejectButton>
            </Grid>
          ) : adminPrDetails?.status === "approved" ? (
            <Grid item xs={6}>
              <Chip
                style={{
                  /*  height: "40px", */
                  width: "100px",
                  borderRadius: "25px",
                  backgroundColor: "var(--button-color)",
                  color: "white",
                  float: "right",
                }}
                label="Approved"
              />
            </Grid>
          ) : adminPrDetails?.status === "rejected" ? (
            <Grid item xs={6}>
              <Chip
                style={{
                  /*  height: "40px", */
                  width: "100px",
                  borderRadius: "25px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  float: "right",
                }}
                label="Rejected"
              />
            </Grid>
          ) : adminPrDetails?.status === "pushed" ? (
            <Grid item xs={6}>
              <Chip
                style={{
                  /*  height: "40px", */
                  width: "100px",
                  borderRadius: "25px",
                  // backgroundColor: "#d32f2f",
                  // color: "white",
                  float: "right",
                }}
                label="Pushed"
              />
            </Grid>
          ) : (
            <Grid item xs={6}>
              <Chip
                style={{
                  /*  height: "40px", */
                  width: "100px",
                  borderRadius: "25px",
                  backgroundColor: "#ed6c02",
                  color: "white",
                  float: "right",
                }}
                label="Pending"
              />
            </Grid>
          )}
        </Grid>
      </AdminTitleHolder>
      <StyledCard>
        <CardContent>
          <Grid container spacing={2}>
            {/* {clientId !== 5 ? (
              <>
                <Grid item xs={6} md={6}>
                  <Typography className="label">PROJECT</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.project
                      ? adminPrDetails.project
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </>
            ) : (
              ""
            )} */}

            <Grid item xs={6} md={6}>
              <Typography className="label">PR NUMBER</Typography>
              <VendorCardLabel>
                {adminPrDetails.pr_number
                  ? adminPrDetails.pr_number
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">REQUISITIONER NAME</Typography>
              <VendorCardLabel>
                {adminPrDetails?.User?.first_name
                  ? capitalizeString(adminPrDetails.User?.first_name) +
                    " " +
                    capitalizeString(adminPrDetails.User?.last_name)
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">REQUISITIONER EMAIL</Typography>
              <VendorCardLabel>
                {adminPrDetails?.User?.contact_person_email
                  ? adminPrDetails.User?.contact_person_email
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">COMPANY NAME</Typography>
              <VendorCardLabel>
                {adminPrDetails?.Company?.company_name
                  ? adminPrDetails?.Company?.company_name
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">DESIRED DELIVERY DATE</Typography>
              <VendorCardLabel>
                {adminPrDetails.desired_delivery_date
                  ? moment(adminPrDetails.desired_delivery_date).format(
                      "DD MMM YY"
                    )
                  : "Not Applicable"}
              </VendorCardLabel>
            </Grid>
            {clientId === 5 ? (
              <>
                <Grid item xs={6} md={6}>
                  <Typography className="label">PR AMOUNT</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.pr_amount
                      ? adminPrDetails.pr_amount
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">EXPENSE TYPE</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.expense_type
                      ? adminPrDetails.expense_type.toUpperCase()
                      : "Not Applicable"}
                  </VendorCardLabel>
                </Grid>
              </>
            ) : (
              ""
            )}
            <Grid item xs={6} md={6}>
              <Typography className="label">SHIPPING ADDRESS</Typography>
              <VendorCardLabel>
                {adminPrDetails.shipping_address
                  ? adminPrDetails.shipping_address
                  : "-"}
              </VendorCardLabel>
            </Grid>
            {clientId !== 5 ? (
              <>
                <Grid item xs={6} md={6}>
                  <Typography className="label">BILLING ADDRESS</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.billing_address
                      ? adminPrDetails.billing_address
                      : "-"}
                  </VendorCardLabel>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography className="label">PREFERRED SUPPLIER</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.preferred_supplier
                      ? adminPrDetails.preferred_supplier
                      : "-"}
                  </VendorCardLabel>
                </Grid>
              </>
            ) : (
              ""
            )}

            <Grid item xs={6} md={6}>
              <Typography className="label">REASON OF PURCHASE</Typography>
              <VendorCardLabel>
                {adminPrDetails.reason_of_purchase
                  ? adminPrDetails.reason_of_purchase
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">URGENCY LEVEL</Typography>
              <VendorCardLabel>
                {adminPrDetails.urgency_level
                  ? adminPrDetails.urgency_level.toUpperCase()
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography className="label">REMARKS</Typography>
              <VendorCardLabel>
                {adminPrDetails.remarks ? adminPrDetails.remarks : "-"}
              </VendorCardLabel>
            </Grid>
          </Grid>
          <br />
          <br />
          <VendorCardTitle>Item Details</VendorCardTitle>
          <CustomTableContainer component={Card}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow
                  style={{
                    backgroundColor: "#e1ebfa",
                  }}
                >
                  <TableCell width="10%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Sr. No.</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Item Code</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Item Name</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Item Description</TableHeaderFont>
                  </TableCell>

                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Req Qty</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>UOM</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Frequency</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont>Justification/Purpose</TableHeaderFont>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itemList.length > 0 ? (
                  itemList.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          width="10%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.item_code ? row.item_code : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.item_name ? row.item_name : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.item_description
                            ? row.item_description
                            : "Not Applicable"}
                        </TableCell>

                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.quantity ? row.quantity : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.UOM ? row.UOM : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.frequency ? row.frequency : "Not Applicable"}
                        </TableCell>
                        <TableCell
                          width="20%"
                          style={{
                            fontFamily: "var(--font-family-reg)",
                            fontSize: "12px",
                            textAlign: "center",
                          }}
                        >
                          {row.purpose ? row.purpose : "-"}
                        </TableCell>
                        {/* <TableCell>
                          {row.status !== null ? (
                            <Chip
                              label={row.material_status.toUpperCase()}
                              color={
                                row.material_status === "pending"
                                  ? "warning"
                                  : row.material_status === "approved"
                                  ? "success"
                                  : row.material_status === "rejected"
                                  ? "error"
                                  : "default"
                              }
                              size="small"
                              style={{ fontSize: "9px" }}
                            />
                          ) : (
                            "Not Applicable"
                          )}
                        </TableCell> */}
                        {/* <TableCell style={{ textAlign: "center" }}>
                          {row?.action_performed ? (
                            <Chip
                              label={row?.action_performed.toUpperCase()}
                              color={
                                row?.action_performed === "pending"
                                  ? "warning"
                                  : row?.action_performed === "approved"
                                  ? "success"
                                  : row?.action_performed === "rejected"
                                  ? "error"
                                  : "default"
                              }
                              size="small"
                              style={{ fontSize: "9px" }}
                            />
                          ) : (
                            "-"
                          )}
                        </TableCell> */}
                        {/* <TableCell style={{ textAlign: "center" }}>
                          <Tooltip title="View Item">
                            <Link
                              style={{ textDecoration: "none" }}
                              // eslint-disable-next-line
                              to={"/app/items-list-view/" + `${row.id}`}
                            >
                              <RemoveRedEyeIcon
                                style={{
                                  fill: "royalblue",
                                  height: "18px",
                                  width: "18px",
                                }}
                              />
                            </Link>
                          </Tooltip>
                        </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>Fetching items..</TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <br />
          <br />
          <VendorCardTitle>Workflow Details</VendorCardTitle>
          <CustomTableContainer>
            <Table aria-label="workflow table">
              <TableHead>
                <TableRow style={{ backgroundColor: "#e1ebfa" }}>
                  <TableCell width="10%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">Step</TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">
                      E-Mail
                    </TableHeaderFont>
                  </TableCell>
                  <TableCell width="15%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">
                      Status
                    </TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">
                      Action Performed
                    </TableHeaderFont>
                  </TableCell>
                  <TableCell width="20%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">
                      Reason
                    </TableHeaderFont>
                  </TableCell>
                  <TableCell width="15%" style={{ textAlign: "center" }}>
                    <TableHeaderFont variant="subtitle2">
                      Updated At
                    </TableHeaderFont>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {adminPrDetails?.steps?.length > 0 ? (
                  adminPrDetails?.steps?.map((step, index) => (
                    <TableRow key={step.id}>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        {step.step}
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        {step.approver_email || "N/A"}
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        <Chip
                          label={capitalizeString(step.status)}
                          color={
                            step.status === "pending"
                              ? "warning"
                              : step.status === "approved"
                              ? "success"
                              : step.status === "rejected"
                              ? "error"
                              : "default"
                          }
                          size="small"
                        />
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        <Chip
                          label={capitalizeString(step.action_performed)}
                          color={
                            step.action_performed === "pending"
                              ? "warning"
                              : step.action_performed === "approved"
                              ? "success"
                              : step.action_performed === "rejected"
                              ? "error"
                              : "default"
                          }
                          size="small"
                        />
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        {step.reason
                          ? step.reason.replace(/<\/?[^>]+(>|$)/g, "")
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        {step.action_performed !== "pending" &&
                        step.action_performed !== "no action"
                          ? moment(step.updatedAt).format(
                              "DD-MMM-YYYY hh:mm:ss A"
                            )
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} style={{ textAlign: "center" }}>
                      No workflow steps available.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CustomTableContainer>
          <br />
          <br />
          <VendorCardTitle>Documents</VendorCardTitle>
          {clientId !== 5 && clientId !== 3 ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6} md={4}>
                  <Typography className="label">PR Document</Typography>
                  <VendorCardLabel>
                    {adminPrDetails.Pr_document ? (
                      adminPrDetails.Pr_document ? (
                        <Tooltip title="Download Document">
                          <CustomDocumentLink
                            href={adminPrDetails.Pr_document}
                            target="_blank"
                          >
                            <InsertDriveFileOutlinedIcon
                              style={{
                                marginTop: "-1px",
                                marginRight: "3px",
                                height: "12px",
                                width: "12px",
                              }}
                            />
                            Pr document
                          </CustomDocumentLink>
                        </Tooltip>
                      ) : (
                        <Typography className="label">
                          <InfoIcon
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no PR Document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label">
                        <InfoIcon
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no PR Document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </Grid>
              </Grid>
              <br />
            </>
          ) : (
            ""
          )}

          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <Typography className="label">Supporting Documents</Typography>
              {adminPrDetails?.Pr_documents !== undefined &&
              adminPrDetails?.Pr_documents !== null &&
              adminPrDetails?.Pr_documents.length > 0 ? (
                adminPrDetails?.Pr_documents.map((item, index) => (
                  <VendorCardLabel key={index}>
                    <Tooltip title="Download Document">
                      <CustomDocumentLink
                        key={index}
                        href={item?.supporting_documents}
                        target="_blank"
                      >
                        <InsertDriveFileOutlinedIcon
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Supporting document
                      </CustomDocumentLink>
                    </Tooltip>
                  </VendorCardLabel>
                ))
              ) : (
                <Typography className="label">
                  <InfoIcon
                    sx={{
                      marginTop: "-1px",
                      marginRight: "1px",
                      fill: "grey",
                      height: "15px",
                      width: "15px",
                    }}
                  />{" "}
                  There are no supporting documents
                </Typography>
              )}
            </Grid>
          </Grid>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Do you really want to approve?"}
            </DialogTitle>
            <DialogContent>
              <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={onEditorStateChange}
                placeholder="Start typing a suggestion.."
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                variant="outlined"
                style={{
                  borderColor: "rgb(28 182 151)",
                  color: "#0f0f0f",
                }}
                size="small"
                // color="success"
              >
                Cancel
              </Button>
              <ApproveButton
                variant="contained"
                style={{
                  float: "right",
                  backgroundColor: "var(--button-color)",
                  color: "white",
                }}
                onClick={(e) => handleAcceptRejectFc("approve")}
                autoFocus
                size="small"
                disabled={approve_reject_loading}
              >
                {approve_reject_loading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  "Approve"
                )}
              </ApproveButton>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openRej}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Do you really want to reject?"}
            </DialogTitle>
            <DialogContent>
              <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={onEditorStateChange}
                placeholder="Start typing a remark.."
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseRej}
                variant="outlined"
                style={{
                  borderColor: "rgb(211 47 47)",
                  color: "#0f0f0f",
                }}
                size="small"
              >
                Cancel
              </Button>
              <RejectButton
                color="error"
                variant="contained"
                style={{
                  float: "right",
                }}
                onClick={(e) => handleAcceptRejectFc("reject")}
                autoFocus
                size="small"
                disabled={approve_reject_loading}
              >
                {approve_reject_loading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  "Reject"
                )}
              </RejectButton>
            </DialogActions>
          </Dialog>
        </CardContent>
      </StyledCard>
    </>
  );
}
export default AdminPrsViewContent;

export const StyledCard = materialStyles(Card)`
  box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
  flex-direction: column;
  border: none;
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 1em;
  `;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorCardTitle = styled.div`
  text-align: left;
  padding: 0px 20px 15px 0px;
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 18px;
  color: #212134;
`;
